const state = {
  isGuest: true,
  authToken: null,
  username: null,
  segment: "anonymous",
};

export default state;
